import React, { useState } from 'react';
import isNil from 'utils/isNil';
import { Form } from 'antd';
import {
  industryList,
  otherIndustryList,
  focusOptions,
} from 'components/Form/utils/generalFormData';
import TextField from 'components/Form/TextField';
import Select from 'components/Form/Select';
import FormLabelWithField from 'components/Form/FormLabelWithField';
import Button from 'components/Button';
import { FormContainer } from '../../styles';
import { LaborRateCalcFormContainer } from '../styles';
import useLaborRateCalcImages from 'hooks/useLaborRateCalcImages';

const LaborRateCalcHomeForm = ({ formValues, onClickNext, ...otherProps }) => {
  const [isUpdate, setUpdate] = useState(false);
  const [values, setValues] = useState({
    industry: formValues['industry'] || '',
    otherIndustry: formValues['otherIndustry'] || '',
    businessFocus: formValues['businessFocus'] || '',
    company: formValues['company'] || '',
  });

  const pageImages = useLaborRateCalcImages();
  const manImage =
    pageImages
      .filter(imageItem => imageItem.node.internalName === 'LaborRateCalc Home')
      .map(imageItem => imageItem.node.image?.file?.url)[0] || '';

  const [formValid, setFormValid] = useState({
    industry: 0,
    otherIndustry: 0,
    businessFocus: 0,
    company: 0,
  });

  const onHandleChange = (id, newValue) => {
    const tmpValues = { ...values };
    tmpValues[id] = newValue;
    setValues(tmpValues);
    checkFieldValidate(id, newValue);
  };

  const onClickStart = () => {
    if (onClickNext !== undefined) {
      if (checkAllValidate()) {
        onClickNext(values);
      }
    }
  };

  const checkFieldValidate = (id, value) => {
    const fieldValidation = formValid;

    fieldValidation[id] = 1;
    if (id === 'otherIndustry') {
      if (values['industry'] == 'Other') {
        fieldValidation[id] = value.length >= 1 ? 1 : -1;
      }
    } else {
      fieldValidation[id] = value != '' ? 1 : -1;
    }

    setFormValid(fieldValidation);
    setUpdate(!isUpdate);

    return fieldValidation[id];
  };

  const checkAllValidate = () => {
    const keys = Object.keys(values);
    const stepValid = keys.filter(element => checkFieldValidate(element, values[element]) === 1)
      .length;
    return stepValid === keys.length;
  };

  return (
    <FormContainer {...otherProps}>
      <div className="section-tool-page-form--wrapper">
        <div className="section-tool-page-form--container">
          <LaborRateCalcFormContainer {...otherProps}>
            <div className="labor-rate-calc-home-form--container">
              <div className="labor-rate-calc-home-form--left-side">
                <Form
                  data-position="Labor Rate Calculator Form"
                  className="labor-rate-calc-home-form--form"
                >
                  <Form.Item className="labor-rate-calc-home-form--form-item">
                    <FormLabelWithField
                      label="What industry do you do the most business in?"
                      isRequired={false}
                    >
                      <Select
                        id="industry"
                        placeholder="Select Industry"
                        options={industryList}
                        formValid={formValid}
                        handleChange={onHandleChange}
                        defaultValue={values['industry']}
                      />

                      {values['industry'] == 'Other' && (
                        <Select
                          id="otherIndustry"
                          className="labor-rate-calc-home-form--other-industry"
                          placeholder="Select Other Industry"
                          options={otherIndustryList}
                          formValid={formValid}
                          handleChange={onHandleChange}
                          defaultValue={values['otherIndustry']}
                        />
                      )}
                    </FormLabelWithField>
                  </Form.Item>

                  <Form.Item className="labor-rate-calc-home-form--form-item">
                    <FormLabelWithField label="Business Focus" isRequired={false}>
                      <Select
                        id="businessFocus"
                        placeholder="Select Focus"
                        options={[{ label: 'Select Focus', value: '' }, ...focusOptions]}
                        formValid={formValid}
                        handleChange={onHandleChange}
                        defaultValue={values['businessFocus']}
                      />
                    </FormLabelWithField>
                  </Form.Item>

                  <Form.Item className="labor-rate-calc-home-form--form-item">
                    <FormLabelWithField label="Company Name" isRequired={false}>
                      <TextField
                        className="bc-step--field-text"
                        id="company"
                        type="text"
                        placeholderText={'Enter Company Name'}
                        values={values}
                        formValid={formValid}
                        showOnlyFormError
                        handleChange={onHandleChange}
                      />
                    </FormLabelWithField>
                  </Form.Item>

                  <Form.Item
                    data-position="Calculator - CTA"
                    className="labor-rate-calc-home-form--form-item"
                  >
                    <Button
                      className="labor-rate-calc-home-form--submit-button"
                      type="primary"
                      width="100%"
                      shadow={false}
                      onClick={onClickStart}
                    >
                      Get Started
                    </Button>
                  </Form.Item>

                  <div className="labor-rate-calc-home-form--footer-description">
                    This interactive calculator is made available to you as a self-help tool for
                    your independent use and is not intended to provide financial advice.
                  </div>
                </Form>
              </div>
              <div className="labor-rate-calc-home-form--right-side">
                <img src={manImage} className="labor-rate-calc-home-form--man-image" />
              </div>
            </div>
          </LaborRateCalcFormContainer>
        </div>
      </div>
    </FormContainer>
  );
};

export const LRCHomeForm = LaborRateCalcHomeForm;
